/**
 * @typedef {import('./lib/index.js').Value} Value
 * @typedef {import('./lib/index.js').Encoding} Encoding
 * @typedef {import('./lib/index.js').Options} Options
 * @typedef {import('./lib/index.js').Extension} Extension
 * @typedef {import('./lib/index.js').Handle} Handle
 * @typedef {import('./lib/index.js').Transform} Transform
 * @typedef {import('./lib/index.js').Token} Token
 * @typedef {import('./lib/index.js').CompileContext} CompileContext
 * @typedef {import('./lib/index.js').OnEnterError} OnEnterError
 * @typedef {import('./lib/index.js').OnExitError} OnExitError
 *
 * @typedef {import('./lib/index.js').OnEnterError} OnError
 *   To do: deprecate next major.
 */
export {fromMarkdown} from './lib/index.js'
